import React, { useRef } from 'react';
import { useStep } from '../../hooks/useStep';
import { trail, fromTo, val } from 'light-trails';
export const Fade = props => {
  const ref = useRef(null);
  useStep(props.in, ({
    duration
  }) => trail(ref.current, [fromTo({
    opacity: val(0, 1)
  }, duration.normal)]), {
    title: '→Fade'
  });
  useStep(props.out, ({
    duration
  }) => trail(ref.current, [fromTo({
    opacity: val(1, 0)
  }, duration.normal)]), {
    title: '←Fade'
  });
  return React.createElement("div", {
    ref: ref
  }, props.children);
};